<template>
    <cadastro-simples-list
        endpoint="grupo-pontuacao-aluno"
        rota-base="/admin/grupo-pontuacao-aluno"
        titulo="GRUPOS DE PONTUAÇÃO DE ALUNO"
        titulo-singular="Grupo de Pontuação de Aluno"
        :colunas-extras='[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
